{
  "cms.create.articleTeaser.tabCard": "Luo uusi kortti",
  "cms.create.articleTeaser.tabButton": "Luo uusi nappi",
  "cms.create.card.heading": "Uusi etusivun kortti",
  "cms.create.card.next": "Seuraava",
  "cms.create.page.heading": "Luo uusi sivu",
  "cms.create.page.categoryMissing": "Sisältökategoriaa \"tyosuhde\" ei löytynyt. Sivua ei voi luoda ennen kuin kategoria on olemassa.",
  "cms.create.page.categoryLoading": "Ladataan kategorioita…",
  "cms.create.page.categoriesError": "Kategorioiden lataus epäonnistui. Yritä myöhemmin uudelleen.",
  "cms.create.page.slugCollisionWarning": "Tällä tai lähes samalla otsikolla on jo sivu. Sivua ei voi luoda, ennen kuin vaihdat otsikon.",
  "cms.create.back": "Takaisin",
  "cms.create.cancel": "Peruuta",
  "cms.create.submit": "Luo luonnos",
  "cms.create.committing": "Luodaan…",
  "cms.create.savedToDrafts": "Tallennettu Luonnokset-listaan",
  "cms.create.error.page": "Sivun luonti epäonnistui. Yritä uudelleen.",
  "cms.create.error.slugCollision": "Tällä tai lähes samalla otsikolla on jo sivu. Vaihda otsikko ja yritä uudelleen.",
  "cms.create.error.partial": "Sivu luotiin, mutta etusivun kortin luonti epäonnistui.",
  "cms.create.error.schedule": "Sisältö tallennettiin, mutta kaikkia ajastuksia ei voitu tallentaa.",
  "cms.create.partial.openCreated": "Siirry muokkaamaan",
  "cms.create.partial.retrySchedule": "Yritä ajastusta uudelleen",
  "cms.create.partial.retryCard": "Yritä korttia uudelleen",
  "cms.create.previewPlaceholder": "Esikatselu tulee näkyviin, kun sisältö on tallennettu.",
  "cms.create.benefit.heading": "Uusi etu/alennus",
  "cms.create.benefit.categoryMissing": "Sisältökategoriaa \"jasenyys\" ei löytynyt. Etua ei voi luoda ennen kuin kategoria on olemassa.",
  "cms.create.error.standalone": "Sisällön luonti epäonnistui. Yritä uudelleen.",
  "cms.create.error.title": "Otsikko on pakollinen (enintään 200 merkkiä).",
  "cms.create.sidebarLink.heading": "Uusi etusivun nappi",
  "cms.create.sidebarLink.next": "Seuraava",
  "cms.create.sidebarLink.error.partial": "Sivu luotiin, mutta napin luonti epäonnistui.",
  "cms.create.sidebarLink.partial.retryButton": "Yritä nappia uudelleen",
  "cms.create.sidebarLink.categoryMissing": "Sisältökategoriaa \"lakikaveri\" ei löytynyt. Nappia ei voi luoda ennen kuin kategoria on olemassa.",
  "cms.create.sidebarLink.pagesError": "Sivulistan lataus epäonnistui. Sivuun osoittavaa nappia ei voi luoda juuri nyt. Yritä myöhemmin uudelleen.",
  "cms.create.templatePicker.backToPageEditing": "Palaa sivun muokkaukseen",
  "cms.create.templatePicker.label": "Valitse linkki tai valmis sivupohja",
  "cms.create.templatePicker.fixedLabel": "Valitse valmis sivupohja",
  "cms.create.templatePicker.contact": "Ota yhteyttä",
  "cms.create.templatePicker.benefits": "Edut ja alennukset",
  "cms.create.templatePicker.videos": "Lakiruutu-videot",
  "cms.create.templatePicker.destination": "Kortti/nappi vie valittuun näkymään",
  "cms.create.templatePicker.loadError": "Sivupohjien lataus epäonnistui.",
  "cms.create.templatePicker.selectedLoadError": "Valitun sivupohjan lataus epäonnistui.",
  "cms.create.templatePicker.retry": "Yritä uudelleen",
  "cms.create.templatePicker.loadMore": "Näytä lisää sivupohjia",
  "cms.create.templatePicker.loading": "Ladataan sivupohjia…",
  "cms.create.templatePicker.replaceTitle": "Korvataanko tallentamattomat muutokset?",
  "cms.create.templatePicker.replaceDescription": "Valinta muuttaa vain tallentamatonta luontilomaketta.",
  "cms.create.templatePicker.cancel": "Peruuta",
  "cms.create.templatePicker.continue": "Jatka",
  "cms.create.templatePicker.locale.fi": "Ota käyttöön suomen sisältökieli",
  "cms.create.templatePicker.locale.sv": "Ota käyttöön ruotsin sisältökieli",
  "cms.create.templatePicker.locale.en": "Ota käyttöön englannin sisältökieli",
  "cms.create.videoListing.heading": "Uusi video",
  "cms.create.videoListing.categoryMissing": "Videokategoriaa \"lakikaveri\" ei löytynyt. Videota ei voi luoda ennen kuin kategoria on olemassa."
}
